import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';

const ButtonEntry = ({
    title,
    linkType,
    linkTypeQuery,
    linkTypePayload,
    autoLoginRedirectUrl,
    styles,
    structureType,
}) => (
    <Button
        attributes={{
            label: title,
            path: autoLoginRedirectUrl
                ? 'custom'
                : {
                    type: linkType,
                    ...(linkTypePayload && {
                        payload: linkTypePayload,
                    }),
                    ...(linkTypeQuery && {
                        query: linkTypeQuery,
                    }),
                },
            ...(autoLoginRedirectUrl && { customPath: autoLoginRedirectUrl }),
        }}
        styles={styles}
        structureType={structureType}
    />
);

ButtonEntry.propTypes = {
    autoLoginRedirectUrl: PropTypes.string,
    linkType: PropTypes.string,
    linkTypePayload: PropTypes.object,
    linkTypeQuery: PropTypes.object,
    structureType: PropTypes.string,
    styles: PropTypes.object,
    title: PropTypes.string,
};

export default ButtonEntry;
